import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChild } from '@angular/core';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { T2CardComponent } from '../../../../../trip2-theme/components/t2-card/t2-card.component';
import { ReservationService } from '../../../reservations.service';
import { ApprovalTripService } from '../../approval-trip.service';
import { Subscription } from 'rxjs/Subscription';
import { finalize } from 'rxjs/operators';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { ManifestService } from 'app/pages/A2-utils/manifest/manifest.service';
import { PaymentStatusEnum } from 'app/core/enums/payment-status.enum';

@Component({
  selector: 'app-approval-trip',
  templateUrl: './approval-trip.component.html',
  styleUrls: ['./approval-trip.component.scss']
})
export class ApprovalTripComponent implements OnInit, OnDestroy {
  protected selectDeniedReason: any;
  protected selectDenied = false;
  protected paymentDeniedReasonId: any;
  protected definitiveDenial = false;
  protected rejecteDreason = null;
  protected activeBtn = false;
  public isSubmitting = false;
  public hasManifest = false;
  public reviewmanifest = false;
  public subscriptionArray: Subscription[] = [];

  @Input() tripid?: any;
  @Output() eventApproval?: EventEmitter <any> = new EventEmitter <any>();
  @ViewChild('popDenied')cardDenied: T2CardComponent;

  constructor(
    private _approvalService: ApprovalTripService,
    protected _tripService: ReservationService,
    private manifestService: ManifestService,
    private sweetAlertHelper: SweetAlertHelper,
    private toastrAlertHelper: ToastrAlertHelper,
  ) { }

  ngOnInit() {
    this.getSelectDeniedReason();
    this.initSubscription();
  }

  initSubscription(): void {
    this.subscriptionArray.push(
      this._tripService.isManifestReview$.subscribe({
        next: (res) => {
          if (res && res.reviewmanifest) {
            this.reviewmanifest = res.reviewmanifest;
          } else {
            this.reviewmanifest = false;
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.manifestService.manifestLoaded$.subscribe({
        next: (hasManifestLoaded: boolean) => {
          this.hasManifest = !!hasManifestLoaded;
        },
      }),
      this.manifestService.paymentStatusId$.subscribe({
        next: (paymentstatusid: number | null) => {
          if (paymentstatusid && typeof paymentstatusid === 'number') {
            this.activeBtn = paymentstatusid === PaymentStatusEnum.Unpaid;
          }
        },
      }),
    );
  }

  getSelectDeniedReason() {
    this.subscriptionArray.push(
      this._approvalService.getPaymentDeniedReason().subscribe({
        next: (data) => {
          if (data) {
            this.selectDeniedReason = data;
          }
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
        },
      }),
    );
  }

  saveAction() {
    if (this.isSubmitting || !this.activeBtn) {
      return;
    }

    const isDenyAction = !!this.paymentDeniedReasonId;
    if (!isDenyAction && !this.hasManifest) {
      return;
    }

    this.isSubmitting = true;
    if (this.paymentDeniedReasonId) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Are you sure you want to deny this Claim?',
        html: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, deny!',
        cancelButtonText: 'Cancel'
      }).then((result: any) => {
        if (result.value) {
          const data = {
            'tripids': [this.tripid],
            'paymentstatus': 8,
            'rejectedreason': this.rejecteDreason,
            'PaymentDeniedReasonId': this.paymentDeniedReasonId,
            'DefinitiveDenial': this.definitiveDenial,
            'reviewmanifest': this.reviewmanifest,
          };
          this.subscriptionArray.push(
            this._approvalService.putTripPayment(data)
              .pipe(
                finalize(() => {
                  this.isSubmitting = false;
                })
              )
              .subscribe({
              next: (resp) => {
                this.showError(resp, data);
                this.cardDenied.close();
              },
              error: (error) => {
                this.sweetAlertHelper.captureException(error);
              },
            }),
          );
        } else {
          this.paymentDeniedReasonId = undefined;
          this.isSubmitting = false;
        }
      });
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Do you want to pre-approve this claim?',
        html: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes and Continue!',
        cancelButtonText: 'Cancel'
      }).then((result: any) => {
        if (result.value) {
          const data: any = {
            'tripids': [this.tripid],
            'paymentstatus': 9,
            'rejectedreason': this.rejecteDreason,
          };

          if (data && this.reviewmanifest) {
            data.reviewmanifest = this.reviewmanifest;
          }
          this.subscriptionArray.push(
            this._approvalService.putTripPayment(data)
              .pipe(
                finalize(() => {
                  this.isSubmitting = false;
                })
              )
              .subscribe({
              next: (resp) => {
                this.showError(resp, data);
              },
              error: (error) => {
                this.sweetAlertHelper.captureException(error);
              },
            }),
          );
        } else {
          this.isSubmitting = false;
        }
      });
    }
  }

  showError(resp, data) {
    if (resp.tripschangeresponse.length !== 0) {
      const message = [];
      for (const i in resp.tripschangeresponse) {
        if (resp.tripschangeresponse[i].changesuccessfull)  {
          message.push(
            `<div class="color-success"><strong>Trip # ${resp.tripschangeresponse[i].tripid}</strong>
           ${resp.tripschangeresponse[i].error}</div>`
          );
        } else {
          message.push(
            `<br><span class="color-danger"><strong>Trip # ${resp.tripschangeresponse[i].tripid}</strong>
           ${resp.tripschangeresponse[i].error}</span>`
          );
        }
      }
      this.sweetAlertHelper.createCustomAlert({
        html: `<div style="max-height:300px; overflow:auto">
          <h3>Claim Result:</h3> ${message}
       </div>`,
        type: 'info'
      });
    } else {
      this._tripService.emitClaimGridLocalUpdate({
        tripid: this.tripid,
      });
      const textMessage = data.PaymentDeniedReasonId ? 'Denied Claim' : 'Claim Pre-approved';
      this.toastrAlertHelper.success(textMessage, 'success');
      this._tripService.closeModalDriverManifest.next({ closeModal: true });
    }

  }

  cardEmitterAction(event) {
    if (event.isOpen === false) {
      this.selectDenied = false;
    }
  }

  get isDisabled(): boolean {
    return (
      this.selectDenied ||
      !this.activeBtn ||
      this.isSubmitting ||
      !this.hasManifest
    );
  }

  get isActionDisabled(): boolean {
    return !this.activeBtn || this.isSubmitting;
  }

  ngOnDestroy(): void {
    if (this.subscriptionArray.length) {
      this.subscriptionArray.forEach(row => row.unsubscribe());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/approval-trip/component/approval-trip/approval-trip.component.ts